export default __webpack_public_path__ + "static/media/gatsby-icon.72092e07.png";